import script from "./DeleteAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAccountView.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAccountView.vue?vue&type=style&index=0&id=2921d7ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2921d7ec"]])

export default __exports__